export default {"src":"/_next/static/media/bg_mobile_app_download.a6ea1fb2.svg","height":359,"width":390,"blurWidth":0,"blurHeight":0};